import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.css'],
    standalone: false
})
export class WelcomePageComponent implements OnInit {
  // images = [];

  constructor() { }

  ngOnInit() {
    // this.images = [];
    // this.images.push({ source: 'assets/russellTreeBackground.png', alt: 'russell tree background photo', title: 'RT' });
  }

}
